
<div class="popup-tableSelect popup-aside-float">
  <div class="popup-tableSelect-container">
    <div class="popup-tableSelect-header">
      <div class="popup-tableSelect-nbCouvert">{{ getNbCouvertsTotal }}</div>
      <div class="nav-toggle" @click="closePopup">
        <div id="nav-icon3" class="open"><span></span><span></span><span></span><span></span></div>
      </div>
    </div>
    <div class="popup-tableSelect-desc" v-if="!getModSwitchTable">
      <div v-if="getSelectedTables.length === 1">Table</div>
      <div v-if="getSelectedTables.length > 1">Tables</div>
      <div>{{ getSelectedTablesToString }}</div>
    </div>
    <div class="popup-tableSelect-btns black-inputs">
      <div v-if="getGeneraleState === 'PASSAGE' && !passageOpen && !getModSwitchTable">
        <el-button v-if="inCurrentService() && getTableIsAvaible && getLockButtonState === 0" class="dark"
          type="primary" @click="passageOpen = true">Passage</el-button>
        <el-button v-if="getLockButtonState === 0 && getCanBeInverted" class="dark" type="primary"
          @click="invertAttribution()">Inverser le placement</el-button>
        <el-button v-if="getLockButtonState === 0 && getHoursDispoForSelectedTable().length > 0" class="dark"
          type="primary" @click="takeResaOnThisTable">Prendre une réservation</el-button>
        <el-button v-if="getLockButtonState === 0 && getSelectedTables.length === 1 && getNumberOfResa > 0"
          class="dark" type="primary" @click="setModeChangeTable('START')">Changer Table</el-button>
        <el-button v-if="getLockButtonState === 0 && getNumberOfResa <= 0" :disabled="btnLockTable" class="dark"
          type="primary" @click="lockThisTable(true)">Bloquer la table</el-button>
        <el-button v-if="getLockButtonState === 1" :disabled="btnLockTable" class="dark" type="primary"
          @click="lockThisTable(false)">Débloquer la table</el-button>
        <el-button v-if="getLockButtonState === 0 && getTableIsOccuped" class="dark" type="primary"
          @click="unLinkTableToResa('SHOW')">Libérer table</el-button>
        <el-button v-if="getLockButtonState === 0 && getTableIsComming" class="dark" type="primary"
          @click="unLinkTableToResa('CONFIRMED')">Désatribuer table</el-button>
      </div>
      <div v-if="getGeneraleState === 'PASSAGE' && passageOpen && !getModSwitchTable">
        <div>Passage - Nombre de couverts</div>
        <el-input-number class="text-centered dark" size="medium" :min="1"
          v-model="passageNbCouvert"></el-input-number>
        <div v-loading="btnTakeResa">
          <el-button v-if="!btnTakeResa" type="primary" @click="validerPassage">Valider</el-button>
        </div>
      </div>
      <div v-if="getGeneraleState === 'DISPOS' && !getModSwitchTable">
        <el-button class="dark" type="primary" @click="unLinkTable">Libérer la table</el-button>
        <el-button class="dark" type="primary" @click="lockTable">Bloquer la table</el-button>
      </div>
    </div>
  </div>
</div>
